module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonecvm-bottom-01.2@2x.9088cba0.jpg";